module.exports = __webpack_public_path__ + "static/media/protocolo-off.c2611212.svg";